import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { style: { "background-color": "#CCCCCC" } };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-4 q-pa-sm" };
const _hoisted_4 = { class: "col-8 q-pa-sm" };
const _hoisted_5 = { class: "col-4 q-pa-sm" };
const _hoisted_6 = { class: "col-8 q-pa-sm" };
const _hoisted_7 = { class: "value" };
const _hoisted_8 = {
    key: 0,
    class: "col-12 q-pa-sm"
};
const _hoisted_9 = { class: "text-area-value value" };
const _hoisted_10 = { class: "col-4 q-pa-sm" };
const _hoisted_11 = { class: "value" };
const _hoisted_12 = {
    key: 1,
    class: "col-4 q-pa-sm"
};
const _hoisted_13 = { class: "value" };
const _hoisted_14 = {
    key: 2,
    class: "col-8 q-pa-sm"
};
const _hoisted_15 = { class: "value" };
const _hoisted_16 = {
    key: 3,
    class: "col-4 q-pa-sm"
};
const _hoisted_17 = { class: "value" };
const _hoisted_18 = {
    key: 4,
    class: "col-8 q-pa-sm"
};
const _hoisted_19 = { class: "value" };
const _hoisted_20 = {
    key: 5,
    class: "col-4 q-pa-sm"
};
const _hoisted_21 = { class: "label-text" };
const _hoisted_22 = { class: "value" };
const _hoisted_23 = { class: "value" };
const _hoisted_24 = { class: "value" };
const _hoisted_25 = {
    key: 8,
    class: "col-4 q-pa-sm"
};
const _hoisted_26 = { class: "value" };
const _hoisted_27 = {
    key: 9,
    class: "col-4 q-pa-sm"
};
const _hoisted_28 = { class: "value" };
const _hoisted_29 = {
    key: 10,
    class: "col-4 q-pa-sm"
};
const _hoisted_30 = {
    key: 11,
    class: "col-4 q-pa-sm"
};
const _hoisted_31 = { class: "value" };
const _hoisted_32 = {
    key: 12,
    class: "col-4 q-pa-sm"
};
const _hoisted_33 = { class: "value" };
const _hoisted_34 = {
    key: 13,
    class: "col-12 q-pa-sm"
};
const _hoisted_35 = { class: "value" };
const _hoisted_36 = {
    key: 14,
    class: "col-12 q-pa-sm"
};
const _hoisted_37 = { class: "value" };
const _hoisted_38 = {
    key: 15,
    class: "col-12 q-pa-sm"
};
const _hoisted_39 = { class: "value" };
const _hoisted_40 = ["onClick"];
const _hoisted_41 = {
    key: 17,
    class: "col-12 q-pa-sm"
};
const _hoisted_42 = { class: "value" };
const _hoisted_43 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_file_preview = _resolveComponent("file-preview");
    const _component_q_card = _resolveComponent("q-card");
    return (!_ctx.props.row.isDeleted)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["q-pa-sm", _ctx.isMultipleKeiyaku ? _ctx.$q.screen.lt.lg ? 'col-12' : 'col-6' : 'col-12'])
        }, [
            _createVNode(_component_q_card, null, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createVNode(_component_q_card_section, { class: "row justify-between items-center" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", null, _toDisplayString(_ctx.props.row.bukkenName) + " " + _toDisplayString(_ctx.props.row.roomNumber) + "（" + _toDisplayString(_ctx.props.row.nyukyosha) + "） ", 1)
                            ]),
                            _: 1
                        })
                    ]),
                    _createVNode(_component_q_separator),
                    _createVNode(_component_q_card_section, null, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_2, [
                                _createElementVNode("div", _hoisted_3, [
                                    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "label-text" }, "退去予定日", -1)),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.props.row.taikyoYmd), 1),
                                    _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                ]),
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[3] || (_cache[3] = _createElementVNode("div", { class: "label-text" }, "解約日", -1)),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.props.row.kaiyakuYmd == null ? "" : _ctx.dayjs(_ctx.props.row.kaiyakuYmd ?? "").format("YYYY/MM/DD")), 1),
                                    _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                ]),
                                _createElementVNode("div", _hoisted_5, [
                                    _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label-text" }, "退去理由", -1)),
                                    _createElementVNode("div", null, _toDisplayString(_ctx.props.taikyoForInput.taikyoReasons.find(x => x.value === _ctx.props.row.taikyoRiyuKb)?.label), 1),
                                    _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                ]),
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label-text" }, "退去理由の詳細", -1)),
                                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.props.row.taikyoRiyu), 1),
                                    _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                ]),
                                (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== _ctx.KeyReturnNameKb.HandoverDate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "label-text" }, "その他ご契約事項", -1)),
                                        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.props.row.sonotaKeiyaku), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "label-text" }, "連絡先", -1)),
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.props.taikyoForInput.contactKbList.find(x => x.value === _ctx.props.row.renrakuKb)?.label), 1),
                                    _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                ]),
                                _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-8 q-pa-sm" }, null, -1)),
                                (_ctx.props.row.renrakuKb === _ctx.RenrakuKb.Other)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "label-text" }, "氏名", -1)),
                                        _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.props.row.renrakuName), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.props.row.renrakuKb === _ctx.RenrakuKb.Other)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "label-text" }, "入居者との関係性", -1)),
                                        _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.props.row.renrakuRelationship), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                ([_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "label-text" }, "電話番号", -1)),
                                        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.props.row.tel), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                ([_ctx.RenrakuKb.Hojin, _ctx.RenrakuKb.Nyukyosha, _ctx.RenrakuKb.Other].includes(_ctx.props.row.renrakuKb))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "label-text" }, "メールアドレス", -1)),
                                        _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.props.row.email), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnName), 1),
                                        _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.props.row.keyReturnYmd), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 6,
                                        class: "col-4 q-pa-sm",
                                        style: _normalizeStyle({ visibility: _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb !== 4 ? 'visible' : 'hidden' })
                                    }, [
                                        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "label-text" }, "鍵返却予定数", -1)),
                                        _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.props.row.numberOfReturnKeys), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ], 4))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA)
                                    ? (_openBlock(), _createElementBlock("div", {
                                        key: 7,
                                        class: "col-4 q-pa-sm",
                                        style: _normalizeStyle({ visibility: _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 3 ? 'visible' : 'hidden' })
                                    }, [
                                        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "label-text" }, "鍵返却予定店舗", -1)),
                                        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.props.row.shopName), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ], 4))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _cache[14] || (_cache[14] = _createElementVNode("div", { class: "label-text" }, "退去立会者", -1)),
                                        _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.props.taikyoForInput.tachiaishaKbnList.find(x => x.value === _ctx.props.row.taikyoTachiaiKb)?.label), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                        _cache[15] || (_cache[15] = _createElementVNode("div", { class: "label-text" }, "退去立会者名", -1)),
                                        _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.props.row.taikyoTachiaiName), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                                    : _createCommentVNode("", true),
                                (_ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                        _cache[16] || (_cache[16] = _createElementVNode("div", { class: "label-text" }, "鍵封筒送付先", -1)),
                                        _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.props.taikyoForInput.contactKbList.find(x => x.value === _ctx.props.row.keyReturnAdrKb)?.label), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.props.row.keyReturnAdrKb === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                                        _cache[17] || (_cache[17] = _createElementVNode("div", { class: "label-text" }, "氏名", -1)),
                                        _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.props.row.soufuName), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.props.row.keyReturnAdrKb === 1 || _ctx.props.row.keyReturnAdrKb === 2)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                        _createElementVNode("div", _hoisted_35, "〒 " + _toDisplayString(_ctx.props.row.postCode) + " " + _toDisplayString(_ctx.props.row.adr1) + _toDisplayString(_ctx.props.row.adr2) + _toDisplayString(_ctx.props.row.adr3), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.props.row.keyReturnAdrKb === 9)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                        _cache[18] || (_cache[18] = _createElementVNode("div", { class: "label-text" }, "自由記入", -1)),
                                        _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.props.row.soufuSonota), 1),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA && _ctx.props.taikyoForInput.inputList.find(x => x.orgNyukyokeiyakuNo === _ctx.props.row.taikyoNo)?.keyReturnNameKb === 3)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _cache[19] || (_cache[19] = _createElementVNode("div", { class: "label-text" }, "破損・汚損申告", -1)),
                                        _createElementVNode("div", _hoisted_39, [
                                            (_ctx.props.row.fileList.filter(x => x.fileKb === 0 && !x.delFlg).length > 0)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 0 && x.delFlg === false), (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: file.fileId,
                                                        class: "row items-center q-gutter-sm"
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: "text-blue cursor-pointer underline-link",
                                                            onClick: ($event) => (_ctx.openHasonPreview(file.fileId))
                                                        }, _toDisplayString(file.fileName), 9, _hoisted_40)
                                                    ]));
                                                }), 128))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                                        ]),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.visibleHasonFileDialog)
                                    ? (_openBlock(), _createBlock(_component_file_preview, {
                                        key: 16,
                                        fileCode: _ctx.FileCode.TaikyoHasonFile,
                                        targetNo: _ctx.props.row.taikyoNo,
                                        index: _ctx.selectedIndex,
                                        result: _ctx.props.result,
                                        fileInfo: _ctx.props.fileInfo,
                                        onClose: _cache[0] || (_cache[0] = ($event) => (_ctx.visibleHasonFileDialog = false))
                                    }, null, 8, ["fileCode", "targetNo", "index", "result", "fileInfo"]))
                                    : _createCommentVNode("", true),
                                (!_ctx.isMMA)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                        _cache[20] || (_cache[20] = _createElementVNode("div", { class: "label-text" }, "破損・汚損以外の添付ファイル", -1)),
                                        _createElementVNode("div", _hoisted_42, [
                                            (_ctx.props.row.fileList.filter(x => x.fileKb === 1 && !x.delFlg).length > 0)
                                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.props.row.fileList.filter(x => x.fileKb === 1 && x.delFlg === false), (file) => {
                                                    return (_openBlock(), _createElementBlock("div", {
                                                        key: file.fileId,
                                                        class: "row items-center q-gutter-sm"
                                                    }, [
                                                        _createElementVNode("span", {
                                                            class: "text-blue cursor-pointer underline-link",
                                                            onClick: ($event) => (_ctx.openOtherPreview(file.fileId))
                                                        }, _toDisplayString(file.fileName), 9, _hoisted_43)
                                                    ]));
                                                }), 128))
                                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [], 64))
                                        ]),
                                        _createVNode(_component_q_separator, { style: { "height": "2px" } })
                                    ]))
                                    : _createCommentVNode("", true),
                                (_ctx.visibleOtherFileDialog)
                                    ? (_openBlock(), _createBlock(_component_file_preview, {
                                        key: 18,
                                        fileCode: _ctx.FileCode.TaikyoOthersFile,
                                        targetNo: _ctx.props.row.taikyoNo,
                                        index: _ctx.selectedIndex,
                                        result: _ctx.props.result,
                                        fileInfo: _ctx.props.fileInfo,
                                        onClose: _cache[1] || (_cache[1] = ($event) => (_ctx.visibleOtherFileDialog = false))
                                    }, null, 8, ["fileCode", "targetNo", "index", "result", "fileInfo"]))
                                    : _createCommentVNode("", true)
                            ])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            })
        ], 2))
        : _createCommentVNode("", true);
}
